/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { Button, Dropdown } from 'react-bootstrap';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import axios from 'axios';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { useDispatch, useSelector } from 'react-redux';
import DialogContentText from '@material-ui/core/DialogContentText';
import { useHistory } from 'react-router-dom';
import ClientTabs from './gridComponents/tabs';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { getClientDetails, dispatchErrorMessages } from '../store/actions';
import './client.css';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import CancellationPopup from '../../../Display/NDC/component/CancellationPopup';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import {
  CLIENT_UNIQUE_ERR,
  ERROR_MESSAGE,
  SUCCESSMESSAGE,
} from './constantData';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import { closeTab } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import TooltipTextField from '../../../../SharedModules/Tooltip/TooltipTextField';
import {
  getAllContactType,
  getContactDetails,
  getExistingContactDetails,
  saveContactData,
  resetContactData as resetPlanContactData,
} from '../../Plan/store/actions';
import {
  checkActionAccessByRole,
  PaperComponent,
} from '../../../../SharedModules/utilities/utilities';

function Maintain(props) {
  const dispatch = useDispatch();
  const clientSearchOrAdd = window.localStorage.getItem('clientSearchOrAdd');

  const clientDetails = useSelector((state) => {
    return state.sharedState.ClientReducer.clientDetails;
  });

  const allContactData = useSelector((state) => {
    return state.sharedState.PlanReducer.allContactData;
  });
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const errorMessagesFromStore = useSelector((state) => {
    return state.sharedState.ClientReducer.errorMessages;
  });
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );

  const intialClientData =
    clientDetails && clientSearchOrAdd === 'search'
      ? clientDetails
      : {
          clientId: '',
          clientName: '',
          superClientName: '',
          lastUpdatedBy: logInUser, // 'DRAMS',
          isNew: clientSearchOrAdd === 'add',
          mailOrderPGMInd: 0,
          corrLinkId: null,
        };
  const [clientData, setClientData] = useState(
    JSON.parse(JSON.stringify(intialClientData))
  );

  const [resetClientData, setResetClientData] = useState(
    JSON.parse(JSON.stringify(intialClientData))
  );
    const [resetContactSnapshot, setResetContactSnapshot] = useState(null);

  const [cancelPopup, setCancelPopup] = useState(false);
  const [savePopup, setSavePopup] = useState(false);
  const [isFormChanged, setIsFormChanged] = useState(true);
  // const [errorMessages, setErrorMessages] = useState(
  //   errorMessagesFromStore ?? []
  // );
  const [errorMessages, setErrorMessages] = useState([]);
  const [successMessages, setSuccessMessages] = useState([]);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [contactErrors, setContactErrors] = useState([]);
  const [contactFormDirty, setContactFormDirty] = useState(false);
  const [showComments, setShowComments] = useState(false);
  const [ccCommentsExist, setCcCommentsExist] = useState(0);
  const [hasAccess, setHasAccess] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );
  const [isEnablebyRole, setIsEnablebyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );
  const history = useHistory();

  const [
    {
      showNameErr,
      showAddrErr,
      showCityErr,
      showStateErr,
      showZipErr,
      showPhoneErr,
      showEmailErr,
    },
    setShowError,
  ] = useState(false);

  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setHasAccess(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);

  useEffect(() => {
    const clientId = window.localStorage.getItem('clientId');
    if (clientSearchOrAdd === 'search') {
      dispatch(getClientDetails(clientId));
      dispatch(
        getExistingContactDetails(
          {
            key: [clientId?.trim()],
            keyTypeCd: 'CLIENT',
          },
          'client'
        )
      );
      dispatch(getAllContactType({ keyTypeCd: 'CLIENT' || 'CGP' }, 'client'));
    } else {
      setClientData({ ...intialClientData });
    }
  }, []);

  const getExistingComments = async () => {
    try {
      const response = await axios.post(
        serviceEndPoint.GET_EXISTING_COMMENT_LINK_IDS,
        {
          corrLinkId: [clientDetails.corrLinkId],
        }
      );
      setCcCommentsExist(
        response.data?.data?.includes(clientDetails.corrLinkId) ? 1 : 0
      );
    } catch (e) {}
  };

  const handleErrorMessages = (messages) => {
    setErrorMessages(messages);
    dispatch(dispatchErrorMessages(messages));
  };

  useEffect(() => {
    getExistingComments();
    if (clientSearchOrAdd === 'search') {
      setClientData(clientDetails);
    }
  }, [clientDetails]);
   useEffect(() => {
    if (
      isFormChanged &&
      allContactData?.key &&
      clientSearchOrAdd === 'search' &&
      !contactFormDirty
    ) {
      setResetContactSnapshot(
        JSON.parse(JSON.stringify(allContactData))
      );
    }
  }, [allContactData, isFormChanged, clientSearchOrAdd, contactFormDirty]);
  useEffect(() => {
    getExistingComments();
  }, [showComments]);

  // handling refresh functionality
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (
          item.navTo === '/maintain' &&
          (!isFormChanged || contactFormDirty)
        ) {
          item.isFormDirty = true;
          if (errorMessages && errorMessages.length > 0) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        } else if (item.navTo === '/maintain') item.isFormDirty = false;
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [isFormChanged, contactFormDirty, errorMessages]);

  // close popup on click button
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/maintain' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/maintain' && item.isFormSave) {
          item.isFormSave = false;
          saveClient(true);
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  const onChange = (e, field) => {
    handleErrorMessages([]);
    setIsFormChanged(false);
    const newClientData = JSON.parse(JSON.stringify(clientData));
    newClientData[field] = e.target.value;
    setClientData(JSON.parse(JSON.stringify(newClientData)));
  };

  const onChangeCheckBox = () => {
    handleErrorMessages([]);
    setIsFormChanged(false);
    const newClientData = JSON.parse(JSON.stringify(clientData));
    newClientData.mailOrderPGMInd = newClientData.mailOrderPGMInd === 0 ? 1 : 0;
    setClientData(JSON.parse(JSON.stringify(newClientData)));
  };

  const saveClient = (wilCloseTab = false) => {
    if (isFormValid()) {
      handleErrorMessages([]);
      const formattedPayload = { ...clientData };
      if (contactFormDirty) {
        let newPhn =
          allContactData &&
          allContactData.phoneNum &&
          allContactData.phoneNum?.replace(/-| |/g, '');
        if (newPhn) {
          newPhn = newPhn?.replace('(', '');
          newPhn = newPhn?.replace(')', '');
          formattedPayload.contactVOList = [
            { ...allContactData, phoneNum: newPhn },
          ];
        } else {
          formattedPayload.contactVOList = [{ ...allContactData }];
        }
      }
      axios
        .post(serviceEndPoint.SAVE_CLIENT, {
          ...formattedPayload,
          isNew: clientSearchOrAdd === 'add',
          lastUpdatedBy: logInUser,
        })
        .then((res) => {
          if (res?.data?.status === '001' && res?.data?.message) {
            const currentClientData = JSON.parse(JSON.stringify(res.data.data));
            if (clientSearchOrAdd === 'add') {
              window.localStorage.setItem('clientSearchOrAdd', 'search');
              window.localStorage.setItem(
                'clientId',
                currentClientData.clientId
              );
            }
            setClientData(currentClientData);
            setResetClientData(currentClientData);
            setSuccessMessages([SUCCESSMESSAGE]);
            setIsFormChanged(true);
            setContactFormDirty(false);
            dispatch(getClientDetails(currentClientData.clientId));
            dispatch(
              getExistingContactDetails(
                {
                  key: [currentClientData.clientId?.trim()],
                  keyTypeCd: 'CLIENT',
                },
                'client'
              )
            );
            dispatch(
              getAllContactType({ keyTypeCd: 'CLIENT' || 'CGP' }, 'client')
            );
            dispatch(
              getContactDetails(
                {
                  keyTypeCd: 'CLIENT',
                  key: currentClientData.clientId?.trim(),
                  contactTypeCd: allContactData?.contactTypeCd,
                },
                'client'
              )
            );
            if (wilCloseTab) {
              closeTab('/maintain', history, dispatch);
            }
          } else if (
            res?.data?.status === 500 &&
            res?.data?.data?.message?.includes('already exists')
          ) {
            setSuccessMessages([]);
            handleErrorMessages([CLIENT_UNIQUE_ERR]);
          } else {
            handleErrorMessages([ERROR_MESSAGE]);
          }
        })
        .catch(() => {
          setSuccessMessages([]);
          handleErrorMessages([ERROR_MESSAGE]);
        });
    } else {
      setSuccessMessages([]);
    }
  };

  const isFormValid = () => {
    const errorMessagesArray = [];
    let ContactErr = false;
    if (!clientData || clientData?.clientId === '') {
      errorMessagesArray.push('Client ID is required');
    }
    if (!clientData || clientData?.clientName === '') {
      errorMessagesArray.push('Client Name is required');
    }
    if (contactFormDirty && contactErrors && contactErrors.length > 0) {
      ContactErr = true;
    }
    const allErrors = ContactErr
      ? contactErrors.concat(errorMessagesArray)
      : errorMessagesArray;
    if (errorMessagesArray.length > 0 || ContactErr) {
      handleErrorMessages([...new Set(allErrors)]);
      return false;
    }
    return true;
  };

  const onReset = () => {
    handleErrorMessages([]);
    setClientData(JSON.parse(JSON.stringify(resetClientData)));
    setIsFormChanged(true);
    setContactFormDirty(false);
    setContactErrors([]);
  };

  const addUpdateContact = (data) => {
    axios
      .post(serviceEndPoint.ADD_UPDATE_CONTACT, [data])
      .then(() => {
        setSuccessMessages([SUCCESSMESSAGE]);
      })
      .catch(() => {});
  };

  const [openDelete, setOpenDelete] = useState(false);
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);

  const handleClientDelete = () => {
    setOpenConfirmDelete(false);
    setOpenDelete(false);
    axios
      .post(serviceEndPoint.DELETE_CLIENT, {
        clientId: clientData?.clientId,
      })
      .then((response) => {
        if (
          response?.data?.message === 'successfully deleted' ||
          response?.data?.status === '001'
        ) {
          const updateTabs =
            JSON.parse(localStorage.getItem('tabItemsData')) == null
              ? []
              : JSON.parse(localStorage.getItem('tabItemsData'));
          const filtered = updateTabs.filter((item) => {
            return item.navTo !== '/maintain';
          });
          localStorage.setItem('tabItemsData', JSON.stringify(filtered));
          props.history.push({
            pathname: '/client',
          });
        } else {
          handleErrorMessages([ERROR_MESSAGE]);
        }
      })
      .catch(() => {
        handleErrorMessages([ERROR_MESSAGE]);
      });
  };

  const handleClickOpenDelete = () => {
    if (clientData?.clientGroup?.length > 0) {
      setOpenDelete(true);
    } else if (clientData?.clientGroup?.length === 0) {
      setOpenConfirmDelete(true);
    } else {
      handleClientDelete();
    }
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
  };
  const isDisabled =
  !Array.isArray(clientData?.clientGroup) || clientData.clientGroup.length < 0;

  const Action = () => {
    return (
      <Dropdown className='icon-dropdown-container'>
        <Dropdown.Toggle
          className='icon-dropdown'
          aria-label='Toggle Action'
          style={{ float: 'right' }}
        >
          <SVGComponent iconName='Export-icon' />
        </Dropdown.Toggle>  
        <Dropdown.Menu>
          <Dropdown.Item
            onClick={isDisabled || !isEnablebyRole ? undefined : handleClickOpenDelete}
            disabled={isDisabled || !isEnablebyRole}
          >
            Delete Client
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  const onConfirmCancel = () => {
    onReset();
    setContactErrors([]);
    setShowError({
      showNameErr: false,
      showAddrErr: false,
      showCityErr: false,
      showStateErr: false,
      showZipErr: false,
      showPhoneErr: false,
      showEmailErr: false,
    });
    if (clientSearchOrAdd === 'search' && resetContactSnapshot) {
      dispatch(
        saveContactData(JSON.parse(JSON.stringify(resetContactSnapshot)))
      );
      if (
        resetContactSnapshot.contactTypeCd &&
        resetContactSnapshot.contactTypeCd !== '-1' &&
        resetClientData?.clientId
      ) {
        dispatch(
          getContactDetails(
            {
              keyTypeCd: 'CLIENT',
              key: resetClientData.clientId.trim(),
              contactTypeCd: resetContactSnapshot.contactTypeCd,
            },
            'client'
          )
        );
      }
    } else if (clientSearchOrAdd === 'add') {
      dispatch(resetPlanContactData());
    }
    setCancelPopup(false);
  };
  return (
    <>
      <CancellationPopup
        label='There are unsaved changes. Do you want to continue?'
        open={cancelPopup}
        handleClose={() => setCancelPopup(false)}
        onConfirmClick={() => onConfirmCancel()}
      />
      <CancellationPopup
        modalTitle='Save'
        label='Are you sure you want to Save your changes? To revert changes, click on Cancel'
        open={savePopup}
        handleClose={() => setSavePopup(false)}
        onConfirmClick={async () => {
          await saveClient();
          setSavePopup(false);
        }}
      />
      <SaveCancelPopup
        open={openConfirmDelete}
        title='Delete'
        moduleName='the Client'
        onConfim={() => {
          setOpenConfirmDelete(false);
          handleClientDelete();
        }}
        onCancel={() => {
          setOpenConfirmDelete(false);
        }}
      />
      <Dialog
        open={openDelete}
        className='multiGroupDialog custom-dialog-box dialog-420'
        onClose={(reason) => {
          if (reason === 'backdropClick' && reason === 'escapeKeyDown') {
            handleCloseDelete();
          }
        }}
        PaperComponent={PaperComponent}
        aria-labelledby='draggable-dialog-title'
      >
        <div style={{ cursor: 'move' }} id='draggable-dialog-title'>
          <DialogContent>
            <div className='custom-panel'>
              <div className='panel-header'>
                <span className='float-left'> Delete Client </span>
                <span
                  className='float-right'
                  role='button'
                  onClick={handleCloseDelete}
                >
                  <i className='fa fa-times-circle' aria-hidden='true' />
                </span>

                <div className='clearfix' />
              </div>
              <div className='text-center modal-alignment'>
                <DialogContentText style={{ color: 'black' }}>
                  To delete a client there cannot be any corresponding groups.
                </DialogContentText>
              </div>
            </div>
          </DialogContent>

          <DialogActions>
            <div className='btn-wrapper my-2'>
              <Button
                onClick={handleCloseDelete}
                color='primary'
                className='btn btn-success btn-search'
                autoFocus
              >
                <SVGComponent iconName='Icon_awesome-check-circle' />
                OK
              </Button>
            </div>
          </DialogActions>
        </div>
      </Dialog>
      <div className='tBillPanel custom-check'>
        <div className='panel tBillPanel-space pb-0'>
          <Spinner load={spinnerLoader} />
          <CustomSeparator parent1='Maintain' parent2='Maintain Client' />
          {!fullScreenView && (
            <>
              <DisplaySuccessMessages successMessages={successMessages} />
              <DisplayErrorMessages errorMessages={errorMessages} />
            </>
          )}
          {!fullScreenView && (
            <fieldset className='custom-fieldset'>
              <form autoComplete='off'>
                <div className='form-wrapper form-wrapper-col-3'>
                  <div className='mui-custom-form input-md' id='Client_ID'>
                    <TextField
                      label='Client ID'
                      fullWidth
                      required
                      placeholder=''
                      value={clientData?.clientId}
                      onChange={(e) => {
                        onChange(e, 'clientId');
                      }}
                      disabled={clientSearchOrAdd === 'search'}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        maxLength: 10,
                        'aria-labelledby': 'Client_ID',
                      }}
                      aria-label='Client_ID'
                    />
                  </div>
                  <div className='mui-custom-form input-md' id='Client_Name'>
                    <TooltipTextField
                      id='Client Name'
                      label='Client Name'
                      fullWidth
                      required
                      placeholder=''
                      value={clientData?.clientName}
                      onChange={(e) => {
                        onChange(e, 'clientName');
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        maxLength: 60,
                        'aria-labelledby': 'Client_Name',
                      }}
                      aria-label='Client_Name'
                      tooltipContent={clientData?.clientname}
                      tooltipTriggerLength={30}
                      disabled={hasAccess !== true}
                    />
                  </div>
                  <div className='mui-custom-form input-md' id='Claim_Prefix'>
                    <TextField
                      label='Claim Prefix' 
                      fullWidth
                      placeholder=''
                      value={clientData?.claimPrefix}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d{0,2}$/.test(value)) {
                          onChange(e, 'claimPrefix');
                        }
                      }}
                      onKeyDown={(e) => {
                        if (['e', 'E', '+', '-', '.'].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      disabled={hasAccess !== true}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        maxLength: 2,
                        type: 'number',
                        'aria-labelledby': 'Claim_Prefix',
                      }}
                      aria-label='Claim_Prefix'
                    />
                  </div>
                </div>
                <div className='form-wrapper form-wrapper-col-3'>
                  <div
                    className='mui-custom-form input-md'
                    id='Super_Client_ID'
                  >
                    <TextField
                      label='Super Client ID'
                      fullWidth
                      placeholder=''
                      value={clientData?.superClientName}
                      onChange={(e) => {
                        onChange(e, 'superClientName');
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        maxLength: 60,
                        'aria-labelledby': 'Super_Client_ID',
                      }}
                      aria-label='Super_Client_ID'
                      disabled={hasAccess !== true}
                    />
                  </div>
                  <div
                    className='col-4'
                    style={{ padding: '35px 14px 0px 22px' }}
                  >
                    <div className='sub-radio text-black sub-label'>
                      <FormControlLabel
                        control={
                          <Checkbox
                            color='primary'
                            checked={clientData?.mailOrderPGMInd}
                            onChange={onChangeCheckBox}
                            disabled={hasAccess !== true}
                          />
                        }
                        label='Client Has Mail Order Option?'
                      />
                    </div>
                  </div>
                  {hasAccess && (
                    <div className='mui-custom-form input-md'>
                      <div className='comment-sec mt-26'>
                        Comments{' '}
                        {parseInt(ccCommentsExist, [0, 1]) === 1 ? (
                          <img
                            role='button'
                            onClick={() => {
                              setShowComments(true);
                            }}
                            alt=' comment '
                            tabIndex={'0'}
                            onKeyDown={(e) => {
                              // Handle Enter and Space key events
                              if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault(); // Prevents the default space scrolling behavior
                                setShowComments(true);
                              }
                            }}
                            src={CommentVisibleIcon}
                          />
                        ) : (
                          <img
                            role='button'
                            onClick={() => {
                              setShowComments(true);
                            }}
                            alt='comment'
                            tabIndex={'0'}
                            onKeyDown={(e) => {
                              // Handle Enter and Space key events
                              if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault(); // Prevents the default space scrolling behavior
                                setShowComments(true);
                              }
                            }}
                            src={CommentIcon}
                          />
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </form>
            </fieldset>
          )}
          {!fullScreenView && (
            <div className='btn-wrapper mb-2'>
              <div className='float-right mt-2 hide-on-print'>
                <Button
                  className='btn btn-success btn-search'
                  data-testid='saveBtn'
                  disabled={(isFormChanged && !contactFormDirty) || hasAccess !== true}
                  onClick={() => setSavePopup(true)}
                >
                  <SVGComponent iconName='Icon-awesome-save' />
                  Save
                </Button>
                <Button
                  onClick={() => setCancelPopup(true)}
                  disabled={isFormChanged && !contactFormDirty}
                  data-testid='cancelBtn'
                  className='btn btn-cancel btn btn-primary'
                >
                  <SVGComponent iconName='Icon-cancel' />
                  Cancel
                </Button>
              </div>
              <div className='clearfix' />
            </div>
          )}
          {!fullScreenView && <Action />}
          {showComments ? (
            <CommentAndCorrespondenceComponent
              setShowComments={setShowComments}
              linkTableName='CLIENT'
              corrLinkId={clientDetails?.corrLinkId}
              rowGridPrimaryKey={clientDetails ? clientDetails?.clientId : 0}
            />
          ) : null}
          <ClientTabs
            clientData={clientData}
            contactData={allContactData}
            setSuccessMessages={setSuccessMessages}
            clientId={clientData?.clientId}
            contactType='Client'
            clientGroup={clientData?.clientGroup ? clientData?.clientGroup : []}
            addUpdateContact={addUpdateContact}
            setErrorMessages={handleErrorMessages}
            setShowError={setShowError}
            setContactErrors={setContactErrors}
            showNameErr={showNameErr}
            showAddrErr={showAddrErr}
            showCityErr={showCityErr}
            showStateErr={showStateErr}
            showZipErr={showZipErr}
            showPhoneErr={showPhoneErr}
            showEmailErr={showEmailErr}
            setIsFormChanged={setIsFormChanged}
            onContactDirtyChange={setContactFormDirty}
            setFullScreenView={setFullScreenView}
            fullScreenView={fullScreenView}
            errorMessages={errorMessages}
            contactFormDirty={contactFormDirty}
            savePopup={savePopup}
          />
        </div>
      </div>
    </>
  );
}
export default withRouter(Maintain);
